var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconCruise = function SvgIconCruise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.212 1.718a16.483 16.483 0 0 1 8.678 14.527v1.045h1.524c.545 0 .986.442.986.986a4.129 4.129 0 0 1-4.124 4.124H3.841A2.24 2.24 0 0 1 1.6 20.159v-1.883c0-.355.19-.678.492-.853l.82-.474a13.704 13.704 0 0 0 5.012-5.009c.78-1.351 1.325-2.74 1.619-4.16H6.339a.985.985 0 0 1-.846-1.493l.637-1.062-.637-1.062a.985.985 0 0 1 .846-1.493h3.413v-.977l.376-.022c.67-.04.923-.04 1.084.047zm8.977 17.544H3.572v.897a.27.27 0 0 0 .207.262l.062.007h14.435c.767 0 1.454-.407 1.836-1.03l.077-.136zM11.731 4.35v12.94h6.187v-1.045a14.51 14.51 0 0 0-5.893-11.684l-.294-.211zM9.759 12.7l-.128.225a15.66 15.66 0 0 1-3.368 4.056l-.37.308h3.866V12.7zm-.27-8.344H7.974l.15.36a.982.982 0 0 1 .079.861l-.053.104-.174.41h1.51l.001-1.735z",
    fill: "#cb8800",
    fillRule: "evenodd"
  })));
};

export default SvgIconCruise;